function getFullName(obj) {
  return `${obj.last_name} ${obj.first_name} ${obj.patronymic || ' '}`; 
}

const mutations = {
  setUsers(state, payload) {
    state.users = payload.map(user => {
      return {
        ...user,
        full_name: getFullName(user),
        roles: user.roles.data,
        permissions: user.permissions.data,
        skills: user.skills.data,
      }
    });;
  },
  addUser(state, payload) {
    state.users.push({
      ...payload,
      full_name: getFullName(payload),
    });
  },
  deleteUser(state, payload) {
    state.users = state.users.filter(user => {
      return user.id !== payload;
    });
  },
  setParticipants(state, payload) {
    state.participants = payload.map(participant => {
      return {
        ...participant,
        full_name: getFullName(participant),
      }
    });
  },
  addParticipant(state, payload) {
    state.participants.push({
      ...payload,
      full_name: getFullName(payload),
    });
  },
  updateParticipants(state, payload) {
    let index = state.participants.findIndex(item => {
      return item.id === payload.id;
    });
    Object.keys(payload).map(key => {
      state.participants[index][key] = payload[key];
    });
  },
  deleteParticipant(state, payload) {
    state.participants = state.participants.filter(participant => {
      return participant.id !== payload;
    });
  },
  setRoles(state, payload) {
    state.roles = payload;
  },
  deleteRole(state, payload) {
    state.roles = state.roles.filter(role => {
      return role.id !== payload;
    });
  },
  setEventRoles(state, payload) {
    state.eventRoles = payload;
  },
  deleteEventRole(state, payload) {
    state.roles = state.eventRoles.filter(eventRole => {
      return eventRole.id !== payload;
    });
  },
};

export default mutations;
